const util = {
  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1, str.length)
  },
  checkState(obj) {
    return !!obj;
  }
}

export default util;